/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PricesInputs */

const en__field_prices = /** @type {(inputs: _Field_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices`)
};

const de__field_prices = /** @type {(inputs: _Field_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

/**
* | output |
* | --- |
* | "Prices" |
*
* @param {_Field_PricesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_prices = /** @type {((inputs?: _Field_PricesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PricesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_prices(inputs)
	return de__field_prices(inputs)
});